import { InfoPanel, Typography } from "@king-ict/eupisi-ui/components";
import { Row, Col } from "react-bootstrap";

import styles from "./AdministrationListHeader.module.scss";

export interface AdministrationListHeaderProps {
  infoMessage: string;
  title: string;
}

export const AdministrationListHeader = ({
  infoMessage,
  title,
}: AdministrationListHeaderProps) => {
  return (
    <Row>
      <Col xs={12}>
        <InfoPanel
          color="success"
          message={infoMessage}
          fullWidth
          className={styles.info}
        ></InfoPanel>
        <Typography variant="XLargeBold" className={styles.title}>
          {title}
        </Typography>
      </Col>
    </Row>
  );
};
